import type { Agent } from "@fingerprintjs/fingerprintjs";

export async function initFingerprint() {
  if (!process.browser) return;
  let deviceId = localStorage.getItem("@deviceId");
  if (!deviceId) {
    // This lib only runs on the clientside
    const FingerprintClient = await import("@fingerprintjs/fingerprintjs");
    const fpClient: Agent = await FingerprintClient.load();

    let result = await fpClient.get({
      excludes: {
        timezone: true,
        timezoneOffset: true,
        adBlock: true,
      },
    } as any);

    localStorage.setItem("@deviceId", result.visitorId);
  }
}

initFingerprint();

export async function getVisitorId() {
  let deviceId = localStorage.getItem("@deviceId") as string;
  if (!deviceId) {
    await new Promise((r) => setTimeout(r, 4000));
  }
  deviceId = localStorage.getItem("@deviceId") as string;
  return deviceId;
}
